export function MergeConflicts() {
  // Placeholder
  return null
}
